import { useFilterQuery } from 'dashboard/components-next/filter-bar/useFilterQuery';

// CRM-01h: os filtros do quadro vivem na URL (dá para mandar o link de um quadro filtrado) e
// ficam lembrados por pipeline neste navegador. A URL vence o lembrado: quem abre um link quer
// ver o que o link diz.
// UI-FILTROS-01 (UF-11): quem lê e escreve é o useFilterQuery, com o esquema do Kanban. Estas
// funções ficam como invólucro, com os nomes e o formato de antes (o spec delas é o gabarito).

// campo na store: chave na URL e tipo dos valores. Todos são listas, menos os dias parados.
const ESQUEMA = {
  status: { param: 'status', type: 'strings' },
  inbox_ids: { param: 'inbox', type: 'ids' },
  team_id: { param: 'team', type: 'ids' },
  assignee_id: { param: 'assignee', type: 'ids' },
  priority: { param: 'priority', type: 'strings' },
  labels: { param: 'labels', type: 'strings' },
  // Só inteiro positivo: o "-3" de um link editado à mão não vai ao servidor.
  stale_days: {
    param: 'stale',
    read: query => {
      const dias = Number(query.stale);
      return Number.isInteger(dias) && dias > 0 ? dias : undefined;
    },
    write: dias => ({ stale: dias ? String(dias) : undefined }),
  },
  q: { param: 'q', type: 'text' },
};

const { toQuery, fromQuery, hasAny } = useFilterQuery(ESQUEMA);

export const filtrosParaQuery = filtros => toQuery(filtros);

export const queryParaFiltros = query => fromQuery(query);

export const temFiltroNaQuery = query => hasAny(query);

// localStorage pode faltar ou recusar (aba anônima, cota): sem ele, o quadro abre sem filtro.
const lembrado = (accountId, pipelineId) =>
  useFilterQuery(ESQUEMA, {
    remember: { key: `pz:kanban:filtros:${accountId}:${pipelineId}` },
  });

export const filtrosLembrados = (accountId, pipelineId) =>
  lembrado(accountId, pipelineId).recall();

export const lembrarFiltros = (accountId, pipelineId, filtros) =>
  lembrado(accountId, pipelineId).store(filtros);
